var map = {
	"./endorsements/booklet.svg": "5a0b",
	"./endorsements/layout-center.png": "c14c",
	"./endorsements/layout-default.png": "ba4d",
	"./endorsements/layout-left.png": "abd9",
	"./endorsements/multiple-endorsements.svg": "b5fe",
	"./endorsements/no_featured.svg": "23cb1",
	"./guide/placeholder.png": "9a4d",
	"./guide/t1-email.png": "cad1",
	"./guide/t1-endorsement-list.png": "0787",
	"./guide/t1-endorsement-statement.png": "f7be",
	"./guide/t1-events.png": "2697",
	"./guide/t1-feature-text.png": "769d",
	"./guide/t1-headshot.png": "ff65",
	"./guide/t1-home-headshot.png": "bbdd",
	"./guide/t1-intro-text.png": "4421",
	"./guide/t1-media-block.png": "9d87",
	"./guide/t1-name.png": "93c3",
	"./guide/t1-open-content.png": "03f5",
	"./guide/t1-petition.png": "3490",
	"./guide/t1-position.png": "117d",
	"./guide/t1-social-links.png": "3868",
	"./guide/t2-email.png": "9991",
	"./guide/t2-endorsement-list.png": "09d1",
	"./guide/t2-endorsement-statement.png": "b0c2",
	"./guide/t2-events.png": "08f1",
	"./guide/t2-feature-text.png": "edc2",
	"./guide/t2-headshot.png": "3adf",
	"./guide/t2-intro-text.png": "4f63",
	"./guide/t2-media-block.png": "2ca6",
	"./guide/t2-name.png": "e522",
	"./guide/t2-open-content.png": "7e63",
	"./guide/t2-petition.png": "4b0c",
	"./guide/t2-position.png": "752e",
	"./guide/t2-social-links.png": "7c1b",
	"./guide/t3-email.png": "8202",
	"./guide/t3-endorsement-list.png": "04a4",
	"./guide/t3-endorsement-statement.png": "bc47",
	"./guide/t3-events.png": "0f57",
	"./guide/t3-feature-text.png": "dc6d",
	"./guide/t3-headshot.png": "04c2",
	"./guide/t3-intro-text.png": "1bb7",
	"./guide/t3-media-block.png": "4d5c",
	"./guide/t3-name.png": "fcec",
	"./guide/t3-open-content.png": "0e16",
	"./guide/t3-petition.png": "0611",
	"./guide/t3-position.png": "5720",
	"./guide/t3-social-links.png": "9f57",
	"./guide/t4-email.png": "e9a8",
	"./guide/t4-endorsement-list.png": "cc04",
	"./guide/t4-endorsement-statement.png": "668d",
	"./guide/t4-events.png": "0035",
	"./guide/t4-feature-image.png": "1397",
	"./guide/t4-feature-text.png": "0cac",
	"./guide/t4-headshot.png": "48b0",
	"./guide/t4-intro-text.png": "0562",
	"./guide/t4-media-block.png": "577c",
	"./guide/t4-name.png": "80fb",
	"./guide/t4-open-content.png": "2283",
	"./guide/t4-petition.png": "40e1",
	"./guide/t4-position.png": "73dc",
	"./guide/t4-social-links.png": "d6d8",
	"./quickstart/screen-dashboard.png": "b78a",
	"./quickstart/screen-endorsements.png": "7c76",
	"./quickstart/screen-support.png": "f2be",
	"./quickstart/screen-theme.png": "9749",
	"./quickstart/screen-wizard.png": "36e7",
	"./quickstart/undraw-building_websites.png": "6957",
	"./quickstart/undraw-product_tour.png": "5486",
	"./quickstart/undraw-remote_team.png": "fad3",
	"./quickstart/undraw-setup_wizard.png": "b3c5",
	"./quickstart/undraw-website_setup.png": "1b99",
	"./quickstart/undraw_content_structure.svg": "4a42",
	"./t1-black.png": "334c",
	"./t1-blue.png": "dcc2",
	"./t1-gray.png": "9505",
	"./t1-purple.png": "2f0d",
	"./t1-salmon.png": "64df",
	"./t1-teal.png": "2ca3",
	"./t2-black.png": "cdba",
	"./t2-blue.png": "bd20",
	"./t2-gray.png": "b7c2",
	"./t2-purple.png": "165a",
	"./t2-salmon.png": "c3cb",
	"./t2-teal.png": "d6f7",
	"./t3-black.png": "5cf5",
	"./t3-blue.png": "3d67",
	"./t3-gray.png": "bfde",
	"./t3-purple.png": "c116",
	"./t3-salmon.png": "340a",
	"./t3-teal.png": "acec",
	"./t4-black.png": "7f25",
	"./t4-blue.png": "7eba",
	"./t4-gray.png": "3007",
	"./t4-purple.png": "6de8",
	"./t4-salmon.png": "3897",
	"./t4-teal.png": "5184",
	"./t5-black.png": "44f1",
	"./t5-blue.png": "d9d9",
	"./t5-gray.png": "5969",
	"./t5-purple.png": "ebe6",
	"./t5-salmon.png": "b635",
	"./t5-teal.png": "7635",
	"./t6-black.png": "6483",
	"./t6-blue.png": "b591",
	"./t6-gray.png": "7902",
	"./t6-purple.png": "ef08",
	"./t6-salmon.png": "9f5a",
	"./t6-teal.png": "d8b8",
	"./thumbnail/t1-black.png": "0014",
	"./thumbnail/t1-blue.png": "07e2",
	"./thumbnail/t1-gray.png": "ef20",
	"./thumbnail/t1-purple.png": "35e3",
	"./thumbnail/t1-salmon.png": "8d6c",
	"./thumbnail/t1-teal.png": "30ce",
	"./thumbnail/t2-black.png": "023b",
	"./thumbnail/t2-blue.png": "4218",
	"./thumbnail/t2-gray.png": "3c16",
	"./thumbnail/t2-purple.png": "d4a5",
	"./thumbnail/t2-salmon.png": "3db1",
	"./thumbnail/t2-teal.png": "ed1e",
	"./thumbnail/t3-black.png": "7a15",
	"./thumbnail/t3-blue.png": "34c2",
	"./thumbnail/t3-gray.png": "39d5",
	"./thumbnail/t3-purple.png": "f1a3",
	"./thumbnail/t3-salmon.png": "c5a8",
	"./thumbnail/t3-teal.png": "5b90",
	"./thumbnail/t4-black.png": "0e95",
	"./thumbnail/t4-blue.png": "d800",
	"./thumbnail/t4-gray.png": "9c85",
	"./thumbnail/t4-purple.png": "fdcb",
	"./thumbnail/t4-salmon.png": "67ee",
	"./thumbnail/t4-teal.png": "bf7f",
	"./thumbnail/t5-black.png": "1fd0",
	"./thumbnail/t5-blue.png": "8231",
	"./thumbnail/t5-gray.png": "a860",
	"./thumbnail/t5-purple.png": "d3b8",
	"./thumbnail/t5-salmon.png": "25e3",
	"./thumbnail/t5-teal.png": "4947",
	"./thumbnail/t6-black.png": "10fc",
	"./thumbnail/t6-blue.png": "889a",
	"./thumbnail/t6-gray.png": "3aa1",
	"./thumbnail/t6-purple.png": "ac2d",
	"./thumbnail/t6-salmon.png": "7279",
	"./thumbnail/t6-teal.png": "ad4d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6926";